var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-row" }, [
    _c(
      "div",
      { staticClass: "alternative-mechanics__select-container" },
      [
        _c("vuex-checkbox", {
          attrs: {
            getter: () => _vm.isSelected(),
            setter: () => _vm.selectionHandler(),
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "alternative-mechanics__name" }, [
      _vm._v(_vm._s(_vm._f("toSentenceCase")(_vm.params.data.title))),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }